


export const GetNextStatusListItem = (Status, type) => {
    if(status[type][Status]){
        return status[type][Status]
    }else{
        return null
    }
};

const status = {
    Ondemand: {
        "Pending": "AssignedAt",
        "Assigned": "StartedAt",
        "Started": "PickedUpAt",
        "Arrived": "PickedUpAt",
        "PickedUp": "DoneAt"
    },
    Pickup: {
        "Pending": "AssignedAt",
        "Assigned": "StartedAt",
        "Started": "PickedUpAt",
        "PickedUp": "DoneAt"
    },
    Delivery: {
        "Pending": "AssignedAt",
        "Assigned": "StartedAt",
        "Started": "DoneAt"
    },

}



export const GetNextStatusInListItem = (Status, type) => {
    if(statusIn[type][Status]){
        return statusIn[type][Status]
    }else{
        return null
    }
};

const statusIn = {
    Ondemand: {
        "Pending": "AssignedIn",
        "Assigned": "StartedIn",
        "Started": "PickedUpIn",
        "Arrived": "PickedUpIn",
        "PickedUp": "DoneIn"
    },
    Pickup: {
        "Pending": "AssignedIn",
        "Assigned": "StartedIn",
        "Started": "PickedUpIn",
        "PickedUp": "DoneIn"
    },
    Delivery: {
        "Pending": "AssignedIn",
        "Assigned": "StartedIn",
        "Started": "DoneIn"
    },

}
